export type InactivityCheckConfig = {
  inactivityDurationMs: number;
  warningDurationSeconds: number;
  activityThrottleMs: number;
};

export const DEFAULT_INACTIVITY_CHECK_CONFIG: InactivityCheckConfig = {
  inactivityDurationMs: 60 * 60 * 1000,
  warningDurationSeconds: 60,
  activityThrottleMs: 1000
};

export type InactivityCheckDialogResult = 'stay' | 'timeout';

export type InactivityCheckEnvironmentOverrides = {
  inactivityCheckTimeoutMs?: number;
  inactivityCheckWarningSeconds?: number;
  inactivityCheckActivityThrottleMs?: number;
};
